/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationInsuranceExpireStatus;

(function (ValidationInsuranceExpireStatus) {
  ValidationInsuranceExpireStatus["EXPIRED"] = "expired";
  ValidationInsuranceExpireStatus["EXPIRE_SOON"] = "expire_soon";
  ValidationInsuranceExpireStatus["URGENT_EXPIRING"] = "urgent_expiring";
})(ValidationInsuranceExpireStatus || (ValidationInsuranceExpireStatus = {}));